<script>

export default {
  data () {
    return {
      dDateFormat: {
        'default': 'DD/MM/YYYY'
      }
    }
  },
  methods: {
    formatDate (date) {
      if (date === null) {
        return ''
      } else {
        if (date.includes('-')) {
          return this.$moment(date, 'YYYY-MM-DD').format(this.dDateFormat.default)
        } else {
          return this.$moment(date, this.dDateFormat.default).format(this.dDateFormat.default)
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/mixins/globals/mx-dates.vue